const a = "_avatarRoot_1lyy2_1", l = "_small_1lyy2_12", t = "_medium_1lyy2_16", _ = "_large_1lyy2_20", e = "_image_1lyy2_29", r = "_avatarImage_1lyy2_37", y = "_avatarFallback_1lyy2_44", m = {
  avatarRoot: a,
  small: l,
  medium: t,
  large: _,
  "extra-large": "_extra-large_1lyy2_24",
  image: e,
  avatarImage: r,
  avatarFallback: y
};
export {
  y as avatarFallback,
  r as avatarImage,
  a as avatarRoot,
  m as default,
  e as image,
  _ as large,
  t as medium,
  l as small
};
//# sourceMappingURL=index.es5718.js.map
